<template>
	<div>
		<div class="template-questions">
			<v-layout justify-end class="template-questions-container">
				<div class="dropdown-container">
					<label
						class="dropdown-label"
						:style="`color:${$appColors.primary}`"
					>
						Cant. Preguntas
					</label>
					<v-select
						background-color="white"
						box
						class="body-1 dropdown-selector"
						color="success"
						:height="35"
						hide-details
						item-text="name"
						item-value="id"
						:items="questionsQuantity"
						:menu-props="{ contentClass: 'type-select-content' }"
						:style="`color:${$appColors.primary}!important;`"
						:value="questionsQuantitySelected"
						@input="changeValue"
					></v-select>
				</div>
				<v-tabs
					v-model="active"
					class="questions-tabs"
					hide-slider
					:show-arrows="false"
					color="gray"
					@change="$emit('on-active', $event)"
				>
					<v-tab
						v-for="(item, itemIndex) in areas" 
						:key="item.id"
						class="template-questions-tabs"
						:style="`${Number(itemIndex) === Number(active) ? `color: ${$appColors.primary}!important;border-bottom: 4px solid currentColor` : 'border-bottom: 4px solid transparent'}`"
						ripple
					>
						{{ item.name }}
					</v-tab>
					<v-tab-item :href="0">
						<v-card flat class="px-5 pt-5 mb-5">
							<div
								v-for="entity in areas[0].entities.filter(e => e.selected)"
								:key="entity.id">
								<table-question
									show-btn
									:questions="entity.questions"
									:title-question="entity.name"
									@on-click="$emit('show-questions', entity)"
								/>
							</div>
						</v-card>
					</v-tab-item>
					<v-tab-item :href="1">
						<v-card flat class="px-5 pt-5 mb-5">
							<div
								v-for="entity in areas[1].entities.filter(e => e.selected)"
								:key="entity.id">
								<table-question
									show-btn
									:questions="entity.questions"
									:title-question="entity.name"
									@on-click="$emit('show-questions', entity)"
								/>
							</div>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-layout>
		</div>
	</div>
</template>

<script>
import tableQuestion from '@/components/surveys/table-question';

function created() {
	this.changeValue(1);
}

function mounted() {
	const icon = document.getElementsByClassName('dropdown-selector')[0]
		.getElementsByClassName('v-icon')[0];
	icon.style = `color:${this.$appColors.success} !important`;
}

function changeValue(value) {
	if (value) {
		this.questionsQuantitySelected = value;
		const newVal = this.questionsQuantity.find(qq => qq.id === value);
		this.$emit('quantity-selected', newVal.quantity);
	}
}

function data() {
	return {
		active: null,
		questionsQuantity: [
			{
				id: 1,
				name: '25 preguntas',
				quantity: 25,
			},
			{
				id: 2,
				name: '50 preguntas',
				quantity: 50,
			},
		],
		questionsQuantitySelected: 0,
	};
}

export default {
	name: 'questions',
	components: {
		tableQuestion,
	},
	created,
	data,
	methods: {
		changeValue,
	},
	mounted,
	props: {
		areas: {
			default: () => [],
			type: Array,
		},
		questions: {
			default: () => [],
			type: Array,
		},
	},
};
</script>

<style lang="scss">
.v-tabs {
	width: 100%;

	&__bar {
		margin-left: auto;
		margin-top: 30px;
		width: 52%;
	}
}

.btn-action .v-btn__content {
	font-family: map-get($fonts, bold);
}

.theme--light.v-sheet {
	background-color: map-get($colors, gray-light);
	padding: 0 !important;
}

.v-tabs__container {
	display: flex;
	height: 30px;
	justify-content: flex-end;
}	

.v-tabs__wrapper {
	border-bottom: 1px solid rgba(72, 127, 255, 0.29);
}

.v-tabs__wrapper {
	background: map-get($colors, gray-light) !important;
}

.table-questions {
	border: 1px solid map-get($colors, gray-slider) !important;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
	margin-top: 24px;
}

.wrapper-questions {
	border-bottom-left-radius: 9px;
	border-bottom-right-radius: 9px;
}

.row-questions {
	border-bottom: 1px solid map-get($colors, gray-light);
	font-size: map-get($colors, small);
	padding: 10px 20px;
}

.title-questions {
	background-color: map-get($colors, gray-white) !important;
	border-bottom: solid 1px map-get($colors, gray-slider) !important;
	border-left: 0px !important;
	border-right: 0px !important;
	border-top: 0px !important;
}

.template-questions-container {
	position: relative;
}

.template-questions-tabs {
	color: color(gray-tabs) !important;

	.v-tabs__item {
		font-family: font(regular);
		font-size: size(small);
		opacity: 1 !important;

		&--active {
			font-family: font(bold);
			font-size: size(medium);
		}
	}
}

.dropdown-container {
	left: 0px;
	position: absolute;
	top: 10px;
	z-index: 1;
}

.v-tabs__wrapper--show-arrows {
	margin-left: 0px !important;
	margin-right: 0px !important;
}

.questions-tabs {
	.v-tabs__icon {
		display: none !important;
	}
}

.dropdown-label {
	font-family: font(regular);
	font-size: size(small11);
}

.dropdown-selector {
	border: 1px solid currentColor;
	border-radius: 5px;
	height: 37px !important;
	width: 133px;

	.v-input__slot {
		border-radius: 5px;
		min-height: 35px !important;

		&:before,
		&:after {
			content: none !important;
		}
	}

	.v-select__selections {
		padding-top: 0px !important;
	}

	.v-input__append-inner {
		margin-top: 7px !important;
		padding-left: 0px !important;
		width: 14px;

		.v-input__icon .v-icon {
			font-size: 30px;
		}
	}

	.v-select__selection {
		font-family: font(regular);
		font-size: size(medium);
		margin: 0px !important;
	}
}

.theme--light.v-select .v-select__selections {
	color: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/questions.vue